import React from 'react';
import PropTypes from 'prop-types';
import Table from 'relements/build/esm/ui/table';
import { LANGUAGE_CODE_TO_TITLE } from '@src/constants/Language';

import styles from './LanguageSettings.scss';

const columns = [
  {
    title: 'Sr No.',
    sortKey: 'serialNumber',
    width: '100px',
  },
  {
    title: 'Language',
    sortKey: 'language',
    width: '30%',
  },
  // {
  //   title: 'Status',
  //   sortKey: 'status',
  //   width: '100px',
  // },
  {
    title: '',
    sortKey: 'notes',
  },
];

// generates column data for a table
const generateColumn = content => ({
  content,
});

// generates relevant data for the table component
const generateData = (data = []) => {
  return data.map((item, index) => {
    const row = {
      columns: [],
      disabled: false,
    };

    const languageString = `${
      item.languageName
    } (${item.languageCode.toUpperCase()})`;

    row.columns.push(generateColumn(index));
    row.columns.push(generateColumn(languageString));
    /* row.columns.push(
      generateColumn(
        <HaptikComponents.Input.Toggle
          value={item.status}
          className={styles.toggle}
          disabled
        />
      )
    ); */
    row.columns.push(
      generateColumn(
        <span className={styles.note}>
          {item.notes ? `(${item.notes})` : null}
        </span>
      )
    );

    return row;
  });
};

const LanguageSettings = ({ supportedLanguages, currentLanguage }) => {
  const DATA = supportedLanguages.map(language => {
    return {
      languageCode: language,
      languageName: LANGUAGE_CODE_TO_TITLE[language],
      status: true,
      notes:
        currentLanguage.languageSource === language ? 'Primary Language' : '',
    };
  });
  const rowData = generateData(DATA);
  return (
    <div className={styles.languageSettings}>
      <Table
        simple
        sortable
        columns={columns}
        rows={rowData}
        className={styles.table}
      />
    </div>
  );
};

export default LanguageSettings;
